import {
  ClientType,
  Credential,
  CredentialEntity,
  RefreshTokenFnReq,
  RefreshTokenFnRes,
  ServiceProvider,
} from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { RefreshCredentialAdapterInteractor } from '../../auth/domain/interactors/refresh-credential.interactor';

export class RefreshGoogleCredentialInteractor implements RefreshCredentialAdapterInteractor {
  private readonly refreshTokenFn = httpsCallable<RefreshTokenFnReq, RefreshTokenFnRes>(
    this.functions,
    'refreshToken',
  );

  constructor(
    private readonly clientId: string,
    private readonly functions: Functions,
  ) {}

  public async execute(credential: Credential): Promise<CredentialEntity> {
    const res = await this.refreshTokenFn({
      provider: ServiceProvider.Google,
      clientId: this.clientId,
      clientType: ClientType.Web,
      refreshToken: credential.refreshToken,
      scopes: credential.scopes,
    });

    return res.data.credential;
  }
}
